var map = {
	"./alert/meta.json": "6ff2",
	"./blocks/meta.json": "f32b",
	"./button/meta.json": "d868",
	"./choice/meta.json": "38de",
	"./field/meta.json": "d9a3",
	"./select/meta.json": "31ae",
	"./test/meta.json": "bb57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f13";